import moment from 'moment';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import DaySummary from 'components/quoteLink/holiday/DaySummary';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import { ReactComponent as Location } from 'images/icons/location.svg';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';

export default function HolidaySummary({
  itinerary,
  itineraryDays,
  className = '',
  updateInView,
}) {
  const { theme } = useSelector((state) => state.ui);
  const [ref, inView] = useInView({ threshold: 0.1 });

  useEffect(() => {
    updateInView(inView);
  }, [inView, updateInView]);

  const countDaysSince = (start, date) => {
    const dateFormat = 'DD/MM/YYYY';
    const startDate = moment(start, dateFormat);
    const diffDate = moment(date, dateFormat);

    return diffDate.diff(startDate, 'days') + 1;
  };

  return (
    <div
      className={`${className} ${itineraryDays[0] === '' ? 'hidden' : ''}`}
      id="summary"
      ref={ref}
    >
      <SectionLabelWithIcon
        label="Holiday Summary"
        icon={<Location />}
        style={{ zIndex: 1, position: 'relative' }}
        iconContainerClassName="section-icon"
        sectionClassName="section-label"
      />
      {itineraryDays &&
        itineraryDays.map((day) => (
          <DaySummary
            sectionTitle={`Day ${countDaysSince(
              itineraryDays[0],
              day,
            )} - ${moment(day, 'DD/MM/YYYY').format('dddd DD MMM YYYY')}`}
            itinerary={itinerary}
            date={day}
            key={uuid()}
          />
        ))}
      <div
        className="border-none xs:border-l-2 xs:border-dashed xs:border-[#18A8CB] xs:px-2 absolute h-full xs:left-[25px] top-5"
        style={{ borderColor: theme.primaryColour || DEFAULT_SECONDARY_COLOUR }}
      />
    </div>
  );
}
